import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { billingCyclesAPI } from '../../services/api';
import { Button } from '../ui/button';
import { Receipt, Wallet, Warning, ArrowRight } from '@phosphor-icons/react';
import { format, parseISO } from 'date-fns';

const money = (n) => `$${(n || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

const KindRow = ({ icon: Icon, label, data, onOpen, testId }) => {
  if (!data || (data.drafts === 0 && data.needs_adjustment === 0)) return null;
  const p = data.periods?.[0];
  return (
    <div className="flex items-center gap-3 rounded-xl bg-white/70 border border-amber-200/60 p-3" data-testid={testId}>
      <div className="w-9 h-9 rounded-lg bg-amber-100 text-amber-800 flex items-center justify-center shrink-0"><Icon weight="duotone" className="w-5 h-5" /></div>
      <div className="flex-1 min-w-0 text-sm">
        <p className="font-medium">{data.drafts} {label}{data.drafts === 1 ? '' : 's'} waiting for approval{data.draft_total ? ` · ${money(data.draft_total)}` : ''}</p>
        <p className="text-xs text-amber-900/80">
          {p ? `Week of ${format(parseISO(p.start), 'MMM d')} – ${format(parseISO(p.end), 'MMM d')}` : ''}
          {data.flagged ? ` · ${data.flagged} flagged (missing clock times / rates)` : ''}
          {data.needs_adjustment ? ` · ${data.needs_adjustment} changed after approval` : ''}
        </p>
      </div>
      <Button size="sm" className="rounded-xl gap-1 shrink-0" onClick={onOpen}>Review <ArrowRight className="w-3.5 h-3.5" /></Button>
    </div>
  );
};

const BillingCycleAlert = () => {
  const [summary, setSummary] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { billingCyclesAPI.pendingSummary().then(r => setSummary(r.data)).catch(() => {}); }, []);
  if (!summary || !summary.total_pending) return null;
  return (
    <div className="rounded-2xl border border-amber-200 bg-amber-50 p-4 space-y-3" data-testid="billing-cycle-alert">
      <div className="flex items-center gap-2">
        <Warning weight="fill" className="w-5 h-5 text-amber-600" />
        <h3 className="font-heading font-semibold text-amber-900">Billing week closed — {summary.total_pending} item{summary.total_pending === 1 ? '' : 's'} need your review</h3>
      </div>
      <KindRow icon={Receipt} label="draft invoice" data={summary.kinds.invoice} onOpen={() => navigate('/invoices?tab=runs')} testId="billing-alert-invoices" />
      <KindRow icon={Wallet} label="draft pay statement" data={summary.kinds.payroll} onOpen={() => navigate('/payroll?tab=runs')} testId="billing-alert-payroll" />
    </div>
  );
};

export default BillingCycleAlert;
